export type GuestUpdateType = 'available' | 'add' | 'remove' | 'update' | 'disconnect';

export interface IChatGuestUpdate {
  roomId: string;
  guestId: string;
  updateType: GuestUpdateType;
}

export class ChatGuestUpdate {
  static fromDto(dto): IChatGuestUpdate {
    return <IChatGuestUpdate>{
      roomId: dto.chatId,
      guestId: dto.userId,
      updateType: dto.type,
    };
  }
}
